import { ErrorLink } from '@apollo/client/link/error';
import { ERROR_PREFIXES } from 'src/common/constants';
import { client } from 'src/services/datadog/client';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';

export const UNAUTHENTICATED_ERROR = 'UnauthenticatedResponse';

export const UnauthenticatedResponseError = createDatadogError(UNAUTHENTICATED_ERROR);

export const GRAPHQL_SIGN_OUT_ERROR = 'User has been signed out due to unauthenticated API response';

export const logUnauthenticatedResponseError: ErrorLink.ErrorHandler = ({
    graphQLErrors,
    networkError,
    operation,
    response,
}) => {
    if (!globalThis.loggedErrors) {
        globalThis.loggedErrors = {};
    }
    if (globalThis.loggedErrors[UNAUTHENTICATED_ERROR]) {
        return;
    }
    globalThis.loggedErrors[UNAUTHENTICATED_ERROR] = true;
    const error = new UnauthenticatedResponseError(`${ERROR_PREFIXES.APPLICATION_SESSION} ${GRAPHQL_SIGN_OUT_ERROR}`);
    client.addError(error, {
        graphQLErrorsAsString: JSON.stringify(graphQLErrors, null, 2),
        graphQLErrors,
        networkError,
        operation,
        response,
    });
};
